import * as PasswordToggleField from '@radix-ui/react-password-toggle-field';
import { Eye, EyeOff } from 'lucide-react';

export function PasswordToggleInput(props: React.ComponentProps<typeof PasswordToggleField.Input>) {
    return (
        <PasswordToggleField.Root>
            <div className="flex items-center w-full border-input bg-background ring-offset-background border rounded-md px-3 py-2 h-10 focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 focus-within:outline-none">
                <PasswordToggleField.Input
                    className="flex-1 bg-transparent border-none outline-none text-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50"
                    id="password-toggle-input"
                    {...props}
                />
                <PasswordToggleField.Toggle
                    className="flex items-center justify-center bg-transparent border-none cursor-pointer px-2"
                    id="password-toggle-toggle"
                >
                    <PasswordToggleField.Icon
                        visible={<Eye />}
                        hidden={<EyeOff />}
                    />
                </PasswordToggleField.Toggle>
            </div>
        </PasswordToggleField.Root>
    );
}
